/* tslint:disable */
/* eslint-disable */
/**
 * Copyright Innov'ATM all rights reserved. This software is the property of Innov'ATM and may not be used in any
 * manner except under a license agreement signed with Innov'ATM.
 *
 * AK RMS API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */

export enum ResourceType {
    'PARKING' = 'PARKING',
    'TERMINAL' = 'TERMINAL',
    'ARR_HALL' = 'ARR_HALL',
    'DEP_HALL' = 'DEP_HALL',
    'BOARDING_GATE' = 'BOARDING_GATE',
    'CHECK_IN' = 'CHECK_IN'
}
